import { combineReducers } from 'redux'
import { reducer as leaseTypeSelectionReducer } from './Dialogs/leaseTypeSelectionSlice'
import { reducer as userDetailsReducer } from './Dialogs/userDetailsSlice'
import { reducer as agencyDetailsReducer } from './Dialogs/agencyDetailsSlice'
import { reducer as ownerDetailsReducer } from './Dialogs/ownerDetailsSlice'
import { reducer as tenantDetailsReducer } from './Dialogs/tenantDetailsSlice'
import { reducer as propertyDetailsReducer } from './Dialogs/propertyDetailsSlice'
import { reducer as leaseTermReducer } from './Dialogs/leaseTermSlice'
import { reducer as leaseSettingsReducer } from './Dialogs/leaseSettingsSlice'
import { reducer as leaseRentAndFeesReducer } from './Dialogs/leaseRentAndFeesSlice'
import { reducer as leaseCommissionReducer } from './Dialogs/leaseCommissionSlice'
import { reducer as leaseConfirmationReducer } from './Dialogs/leaseConfirmationSlice'
import { reducer as leaseInvoicesReducer } from './Dialogs/leaseInvoicesSlice'
import { reducer as chatbotPortfolioReducer } from './state'

const chatbotReducer = combineReducers({
  dialogs: combineReducers({
    leaseTypeSelection: leaseTypeSelectionReducer,
    propertyDetails: propertyDetailsReducer,
    ownerDetails: ownerDetailsReducer,
    tenantDetails: tenantDetailsReducer,
    leaseSettings: leaseSettingsReducer,
    leaseTerm: leaseTermReducer,
    leaseRentAndFees: leaseRentAndFeesReducer,
    leaseCommission: leaseCommissionReducer,
    leaseConfirmation: leaseConfirmationReducer,
    leaseInvoices: leaseInvoicesReducer,
    // Onboarding
    userDetails: userDetailsReducer,
    agencyDetails: agencyDetailsReducer,
  }),
  portfolio: chatbotPortfolioReducer,
})

export default chatbotReducer
